export const hasConversationMessages = (messages: { role: string }[]): boolean =>
  messages.some((m) => m.role === "user" || m.role === "assistant");
